"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bundleProvider = exports.BundleProvider = void 0;
const url_join_1 = __importDefault(require("url-join"));
const cors_import_1 = require("../utils/cors-import");
const interop_require_1 = require("../utils/interop-require");
const CONTEXT_NAME = 'ModuleInjector'; // sync with packages/webpack-legacy-micro-frontend-plugin/src/micro-frontend-plugin.ts:9
const LOADED_MANIFEST_NAME = '__LOADED_MANIFESTS__';
const MANIFEST_CALLBACK_NAME = 'injectManifestCallback';
const MANIFEST_PATH = 'import-manifest.js';
const STORAGE_NAME = '__LOADED_BUNDLES__';
const LOADING_CONTEXT_NAME = '__LOADING_CONTEXT__';
const container = typeof window !== 'undefined' ? window : {};
class BundleProvider {
    constructor() {
        this.loadedBundles = container[STORAGE_NAME] || (container[STORAGE_NAME] = {});
        this.loadedManifests = container[LOADED_MANIFEST_NAME] || (container[LOADED_MANIFEST_NAME] = {});
        this.loadingContexts = container[LOADING_CONTEXT_NAME] || (container[LOADING_CONTEXT_NAME] = {});
        this.injectManifest = (name, manifest) => {
            this.loadedManifests[name] = manifest;
        };
        container[MANIFEST_CALLBACK_NAME] = container[MANIFEST_CALLBACK_NAME] || this.injectManifest;
    }
    async getBundle(namePath, bundlePath) {
        const [bundleName, exportName] = Array.isArray(namePath) ? namePath : [namePath];
        const oldManifest = this.loadedManifests[bundleName];
        await this.loadManifest(bundlePath);
        const newManifest = this.loadedManifests[bundleName];
        if ((oldManifest === null || oldManifest === void 0 ? void 0 : oldManifest.id) !== newManifest.id) {
            delete container[`${bundleName}${CONTEXT_NAME}`];
            const loadingBundlePromise = this.loadBundle(bundleName);
            this.loadingContexts[bundleName] = {
                currentManifestId: newManifest.id,
                loadingPromise: loadingBundlePromise,
            };
            await loadingBundlePromise;
            let currentId = newManifest.id;
            // Если кто-то успел загрузить более свежий бандл, пока мы грузили свой,
            // то дожидаемся загрузки актуального бандла
            while (this.loadingContexts[bundleName].currentManifestId !== currentId) {
                currentId = this.loadingContexts[bundleName].currentManifestId;
                // дожидаемся, пока загрузится актуальный бандл
                await this.loadingContexts[bundleName].loadingPromise;
            }
        }
        return (0, interop_require_1.interopRequire)(this.loadedBundles[bundleName], exportName);
    }
    async loadManifest(path) {
        const manifestPath = (0, url_join_1.default)(path, MANIFEST_PATH);
        return (0, cors_import_1.corsImport)(manifestPath, true);
    }
    async loadBundle(name) {
        const { chunks: allChunks } = this.loadedManifests[name];
        const chunks = allChunks.filter(chunk => !chunk.endsWith('.hot-update.js'));
        let mainIndex = chunks.findIndex(dep => dep.includes(`/${name}.`) && dep.endsWith('.js'));
        if (mainIndex === -1) {
            mainIndex = chunks.length - 1;
        }
        const main = chunks[mainIndex];
        const dependencies = [...chunks.slice(0, mainIndex), ...chunks.slice(mainIndex + 1)];
        await Promise.all(dependencies.map(dependency => (0, cors_import_1.corsImport)(dependency)));
        return (0, cors_import_1.corsImport)(main);
    }
}
exports.BundleProvider = BundleProvider;
exports.bundleProvider = new BundleProvider();
//# sourceMappingURL=bundle-provider.js.map